import { useSite } from "@/lib/site";
import { Reveal, Kicker } from "./Reveal";
import { ProjectCard } from "./ProjectCard";

const SPANS = [
  "md:col-span-12 lg:col-span-8",
  "md:col-span-12 lg:col-span-4",
];

export const Projects = () => {
  const { t } = useSite();
  return (
    <section id="proyectos" className="relative bg-gradient-to-b from-[var(--bg2)] to-[var(--bg3)] py-24 lg:py-36" data-testid="projects-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-14 grid gap-6 lg:mb-20 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Kicker>{t.projects.kicker}</Kicker>
            <h2 className="mt-4 font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-7xl">{t.projects.title}</h2>
          </div>
          <p className="text-base text-[var(--muted)] md:text-lg lg:col-span-5">{t.projects.sub}</p>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-12 lg:gap-6">
          {t.projects.items.map((p, i) => (
            <ProjectCard key={p.id} p={p} index={i} featured={i === 0} soon={t.projects.soon} className={SPANS[i] || "md:col-span-6 lg:col-span-4"} />
          ))}
        </div>
      </div>
    </section>
  );
};
